<template>
  <section class="pick-receiver-modal">
    <modal-template>
      <template #card-title>
        Mijn vergelijking bewaren
      </template>
      <template #comparison-data>
        <div
          v-if="computedComparison.location_object"
          class="usp"
        >
          <icon icon="x-fa-house" />
          <span>{{ computedComparison.location_object.display }}</span>
        </div>
        <slot name="market-usps" />
      </template>
      <template #content>
        <slot
          v-if="showFriendFeature"
          name="modal-content"
        >
          Je kan deze vergelijking bewaren zodat je er later op terug kan komen. Of deel 'm met een
          <span class="bold-text">  Mijn Keuze vriend </span> of bijvoorbeeld vrienden of familie.
        </slot>
        <slot
          v-else
          name="modal-content"
        >
          Je kan deze vergelijking bewaren zodat je er later op terug kan komen, of je kan deze vergelijking delen met
          bijvoorbeeld vrienden of familie.
        </slot>
      </template>
      <template #inputs>
        <div class="radio-group-container">
          <field-label
            name="for-whom"
            text="Vergelijking opslaan voor:"
          />
          <input-radio-default
            id="receiver-self"
            v-model:value="computedReceiver"
            name="receiver"
            native-value="self"
            label="Mijzelf"
          />
          <input-radio-default
            v-if="showFriendFeature"
            id="receiver-friend"
            v-model:value="computedReceiver"
            name="receiver"
            native-value="friend"
            label="Mijn Keuze vriend"
          />
          <input-radio-default
            id="receiver-other"
            v-model:value="computedReceiver"
            name="receiver"
            native-value="other"
            label="Iemand anders"
          />
        </div>
        <transition
          name="generic-fade"
          mode="out-in"
        >
          <div
            v-if="selfSignedOut"
            class="friend-info"
          >
            <TextInput
              id="self-first-name"
              v-model.lazy="computedComparison.first_name"
              name="first_name"
              label="Voornaam"
              :error="error.first_name"
              @keydown.enter="saveComparison"
            />
            <TextInput
              id="self-email-address"
              v-model.lazy="computedComparison.email_address"
              :error="computedComparison.email_address ? error.email_address : null"
              name="email_address"
              label="Email"
              @keydown.enter="saveComparison"
            />
          </div>
          <div
            v-else-if="receiver === 'friend'"
            class="friend-picker"
          >
            <field-dropdown-alt
              v-model:value="computedComparison.friend_id"
              :label="{text: 'Delen met'}"
              name="friend"
              placeholder=" "
              :options="friendOptions"
            />
          </div>
          <div
            v-else-if="receiver === 'other'"
            class="friend-info"
          >
            <TextInput
              id="other-first-name"
              v-model.lazy="computedComparison.first_name"
              name="first_name"
              label="Voornaam"
              :error="error.first_name"
            />
            <TextInput
              id="other-email"
              v-model.lazy="computedComparison.email_address"
              :error=" error.email_address"
              name="email_address"
              label="Email"
            />
          </div>
        </transition>
        <div
          v-if="error.friend_id"
          class="general-error"
        >
          Er ging iets mis met het opslaan van deze vergelijking. Controleer alle velden en probeer het opnieuw.
        </div>
        <div class="bottom-button-container note-container">
          <div
            class="note"
            v-html="modalContent"
          />
          <button-icon-right
            type="cta"
            label="Volgende"
            @click="nextStep()"
          />
        </div>
      </template>
    </modal-template>
  </section>
</template>

<script>

import Icon from 'vue-elements/icon/Icon.vue';
import CardDefault from '../../../elements/card/default/cardDefault.vue';
import ButtonIconRight from '../../../elements/button/icon-right/button-icon-right.vue';
import ModalTemplate from '../shared/ModalTemplate.vue';
import saveComparisonModal from '../assets/js/saveComparisonModal';
import FieldLabel from '../../../elements/field/_shared/label/fieldLabel.vue';
import InputRadioDefault from '../../../elements/input/radio/default/radioDefault.vue';
import FieldDropdownAlt from '../../../elements/field/dropdown/alt/dropdownAlt.vue';
import mijnkeuzeStore from '../../../../templates/sections/mijnKeuze/store/store';
import TextInput from '../../../../templates/vue-elements/input/TextInput.vue';

export default {
    name: 'PickReceiverModal',
    components: {
        TextInput,
        FieldDropdownAlt,
        InputRadioDefault,
        FieldLabel,
        ModalTemplate,
        ButtonIconRight,
        CardDefault,
        Icon,
    },
    mixins: [saveComparisonModal],
    computed: {
        modalContent() {
            if (this.selfSignedOut) {
                return 'We sturen eenmalig een overzicht van deze vergelijking naar je e-mailadres.';
            }
            if (this.receiver === 'self') {
                return 'Sla deze vergelijking op in jouw <span class="bold-text">Bewaarde vergelijkingen'
                    + `</span> in je Mijn Keuze overzicht. We sturen ook de resultaten van je vergelijking eenmalig naar <span class="bold-text">${this.confirmEmailAddress}</span>.`;
            }
            if (this.receiver === 'friend') {
                return `De vergelijking komt in het <span class="bold-text">Mijn Keuze</span> profiel van ${this.friendName}. `
                    + `We sturen ook de resultaten van deze vergelijking eenmalig naar  <span class="bold-text">${this.friendName} </span> per email.`;
            }
            if (this.receiver === 'other') {
                return 'We sturen eenmalig een overzicht van deze vergelijking naar '
                    + `<span class="bold-text"> ${this.confirmFirstName} </span>.`;
            }
            return 'We sturen de vergelijking naar je e-mailadres';
        },
        selfSignedOut() {
            return this.receiver === 'self' && !this.signedIn;
        },
    },
    methods: {
        nextStep() {
            if ((this.receiver === 'other' || this.selfSignedOut) && (!this.comparison.email_address || !!this.error.email_address)) {
                mijnkeuzeStore.dispatch('validateComparison', this.comparison);
                this.setValidityState();
            } else {
                this.$emit('nextStep');
            }
        },
    },
};

</script>
